import api from './api';
import type { 
  ReactivoDTO, 
  ReactivoCreateUpdateDTO, 
  DeleteResponse 
} from '../types/reactivos.types';

const API_URL = '/api/admin/reactivos';

// Forma de la página que devuelve Spring Data (Page<T>).
export interface ReactivosPage {
  content: ReactivoDTO[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number; // página actual (0-based)
}

export interface ReactivosPageParams {
  page: number;
  size: number;
  especialidadId?: number | null;
  temaId?: number | null;
  dificultadId?: number | null;
  q?: string;
}

export const reactivosService = {
  // Listar todos los reactivos
  getAll: async (): Promise<ReactivoDTO[]> => {
    const { data } = await api.get<ReactivoDTO[]>(API_URL);
    return data;
  },

  // Listado paginado con filtros opcionales (server-side).
  getPaginado: async (params: ReactivosPageParams): Promise<ReactivosPage> => {
    const { data } = await api.get<ReactivosPage>(`${API_URL}/paginado`, {
      params: {
        page: params.page,
        size: params.size,
        especialidadId: params.especialidadId || undefined,
        temaId: params.temaId || undefined,
        dificultadId: params.dificultadId || undefined,
        q: params.q?.trim() || undefined,
      },
    });
    return data;
  },

  // Obtener reactivo por ID
  getById: async (id: number): Promise<ReactivoDTO> => {
    const { data } = await api.get<ReactivoDTO>(`${API_URL}/${id}`);
    return data;
  },

  // Crear nuevo reactivo
  create: async (reactivo: ReactivoCreateUpdateDTO): Promise<ReactivoDTO> => {
    const { data } = await api.post<ReactivoDTO>(API_URL, reactivo);
    return data;
  },

  // Actualizar reactivo existente
  update: async (id: number, reactivo: ReactivoCreateUpdateDTO): Promise<ReactivoDTO> => {
    const { data} = await api.put<ReactivoDTO>(`${API_URL}/${id}`, reactivo);
    return data;
  },

  // Eliminar reactivo
  delete: async (id: number): Promise<DeleteResponse> => {
    const { data } = await api.delete<DeleteResponse>(`${API_URL}/${id}`);
    return data;
  },

  // Filtrar por especialidad
  getByEspecialidad: async (especialidadId: number): Promise<ReactivoDTO[]> => {
    const { data } = await api.get<ReactivoDTO[]>(`${API_URL}/especialidad/${especialidadId}`);
    return data;
  },

  // Filtrar por tema
  getByTema: async (temaId: number): Promise<ReactivoDTO[]> => {
    const { data } = await api.get<ReactivoDTO[]>(`${API_URL}/tema/${temaId}`);
    return data;
  },

  // Filtrar por dificultad
  getByDificultad: async (dificultadId: number): Promise<ReactivoDTO[]> => {
    const { data } = await api.get<ReactivoDTO[]>(`${API_URL}/dificultad/${dificultadId}`);
    return data;
  },
};

export default reactivosService;
